export default {
  loadingNewTemplateConfig: false,
  newTemplateConfig: {},
  templateMessageList: {},
  sentNotifications: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  templateAnalytics: {
    sent: {},
    failed: {},
  },
  dynamicTags: {
    business_name: '',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
  },
  templateMessagesLoaded: false,
  templateMessageCreated: false,
  templateMessageUpdated: false,
  templateMessageDeleted: false,
  templateMessageValidationFailed: null,
  templateMessageValidationSuccess: null,
  sentNotificationsLoaded: false,
  templateMessageSent: false,
  templateMessageFailed: {},
  bulkMessagesSent: false,
  bulkSendError: '',
  campaignDetails: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 0,
      from: 0,
      last_page: 0,
      path: '',
      per_page: 0,
      to: 0,
      total: 0,
    },
  },
  campaignDetailsLoaded: false,
  campaignDetailsResData: {
    all: 0,
    sent: 0,
    delivered: 0,
    read: 0,
    failed: 0,
  },
  campaignDetailsResDataLoaded: false,
  /** Tags to be available from the dropdown. */
  notificationTags: [],
  /** Status of tags request. */
  notificationTagsLoaded: false,

  apiError: {},
};
